import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StaticPageService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.baseUrl}/staticpage`,{params:searchParams});
    }

    get(deviceId){
      return this.http.get(`${environment.baseUrl}/staticpage/`+deviceId);
    }

    edit(deviceId,formData){
      return this.http.put(`${environment.baseUrl}/staticpage/`+deviceId,formData);
    }

    create(formData){
      return this.http.post(`${environment.baseUrl}/staticpage`,formData);
    }

    delete(deviceId){
      return this.http.delete(`${environment.baseUrl}/staticpage/`+deviceId);
    }

}
